// Images Slide (gallery)
function initSwiperSliders(section) {
  if (!section) return;
  const thumbsEl = section.querySelector(".product_images_thumbs_mh");
  const mainEl   = section.querySelector(".product_images_mh");
  if (!thumbsEl || !mainEl) return;
  if (mainEl.swiper) mainEl.swiper.destroy(true, true);
  if (thumbsEl.swiper) thumbsEl.swiper.destroy(true, true);
  const thumbsSwiper = new Swiper(thumbsEl, {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
  new Swiper(mainEl, {
    spaceBetween: 10,
    autoHeight: true,
    thumbs: { swiper: thumbsSwiper },
    on: {
      imagesReady() {
        this.updateAutoHeight();
      },
    },
  });
}
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product_section_mh").forEach(section => {
    initSwiperSliders(section);
  });
});
document.addEventListener("shopify:section:load", function (event) {
  const section = event.target;
  if (section.classList.contains("product_section_mh")) {
    initSwiperSliders(section);
  }
});


// Popup
window.openPopup = function(id){
  console.log('open', id); // DEBUG
  document.body.classList.add('popup-open');
  document.querySelector('.popup_overlay_mh').classList.add('active');
  document.getElementById('popup-' + id).style.display = 'block';
}
window.closePopup = function(id){
  document.body.classList.remove('popup-open');
  document.querySelector('.popup_overlay_mh').classList.remove('active');
  document.getElementById('popup-' + id).style.display = 'none';
}
window.closeAllPopups = function(){
  document.body.classList.remove('popup-open');
  document.querySelector('.popup_overlay_mh').classList.remove('active');
  document.querySelectorAll('.popup_content_wrapper_mh')
    .forEach(p => p.style.display = 'none');
}
/*
//Product Bundles
function buyBundle() {
  var forceSubscription = document.querySelector('div#chooseBetween2').classList.contains('forceSubscription');
  var submitButton =document.querySelector('.product_button_mh');
  submitButton.classList.add('loading');

  document.querySelector('input[name="buyBundle"]:checked+label+product-form button[type="submit"]').click();
  setTimeout(function(){
  if(typeof shippingProtectionUpdate == "function")
    shippingProtectionUpdate(); 
    submitButton.classList.remove('loading');
  },2000);
}

function removeActiveClass() {
  document.querySelector('.flex.asasaasass.firstTab').classList.remove('pop-it');
  document.querySelector('product-form button.product-form__submit').classList.add('loading');
  document.querySelector('input[name="buyBundle"]:checked+label+product-form button[type="submit"]').click();
  setTimeout(function() {
    if(typeof shippingProtectionUpdate == "function")
    shippingProtectionUpdate();
    document.querySelector('product-form button.product-form__submit').classList.remove('loading');
  },2000);
}

function updatePricesPlzSubscription() {
  setTimeout(function(){
  var checkItem = document.querySelector('input[name="buyBundle"]:checked+label');
  if(checkItem) {
    var price = checkItem.querySelector('.fullPrice').innerHTML;
    var Cprice = checkItem.querySelector('.compare-at-price').innerHTML;
    var quarterPrice = checkItem.querySelector('.quarterPrice').innerHTML;
    var perPrice = checkItem.querySelector('.perPrice').innerHTML;
    var pricefactor = 1;
    if(document.querySelector('.fixDesignLabels input[name="quantity_bundle"]')){
      pricefactor = document.querySelector('.fixDesignLabels input[name="quantity_bundle"]:checked').value;
    }
    if(pricefactor != 1){
      if(checkItem.querySelector('.fullPrice'+pricefactor))
      price = checkItem.querySelector('.fullPrice'+pricefactor).innerHTML;
      if(checkItem.querySelector('.compare-at-price'+pricefactor))
      Cprice = checkItem.querySelector('.compare-at-price'+pricefactor).innerHTML;
      if(checkItem.querySelector('.quarterPrice'+pricefactor))
      quarterPrice = checkItem.querySelector('.quarterPrice'+pricefactor).innerHTML;
    }
    var fullP = document.querySelector('[data-element-type="pay-full-price"]');
    var quarterP = document.querySelector('[data-element-type="pay-part-price"]');  
    if(fullP) {
      fullP.innerHTML = price; 
    }
    if(quarterP) {
      quarterP.innerHTML = quarterPrice;
    }
    var CP = document.querySelector('.compPriceNEW');
    var PR = document.querySelector('.normalPriceNEW');  
    if(PR)PR.innerHTML = price;
    if(CP)CP.innerHTML = Cprice;
    var CP2  = document.querySelector('.compPriceNEW2');
    var PR2 = document.querySelector('.normalPriceNEW2');  
    if(PR2)PR2.innerHTML = price;
    if(CP2)CP2.innerHTML = Cprice;
    var perPricea = document.querySelector('.perPricePlace');   
    if(perPricea)perPricea.innerHTML = perPrice;
  }

  // find checked input inside .pro_bd_mh
  const checkedBundle = document.querySelector('.pro_bd_mh input[name="buyBundle"]:checked');
  if (!checkedBundle) return;

  // get bundle id from parent .pro_bd_mh
  const bundleId = checkedBundle.closest('.pro_bd_mh')?.dataset.selectorbundle;
  if (!bundleId) return; 

  // remove active from all
  document.querySelectorAll('.product_subscription_bundle_mh')
  .forEach(el => el.classList.remove('active'));

  // add active to matching one
  const target = document.querySelector(
    `.product_subscription_bundle_mh[data-id="${bundleId}"]`
  );
  if (target) target.classList.add('active');

  // now updating content
  const leftSideText = document.querySelector('.pro_bd_mh input[name="buyBundle"]:checked+label .leftSideText');
  const rightSideText = document.querySelector('.pro_bd_mh input[name="buyBundle"]:checked+label .rightSideText');
  if (!leftSideText || !rightSideText) return;
  const leftTarget = document.querySelector('.text_mh_left_p');
  const rightTarget = document.querySelector('.text_mh_right_p');
  if (leftTarget) leftTarget.innerHTML  = leftSideText.innerHTML ;
  if (rightTarget) rightTarget.innerHTML  = rightSideText.innerHTML ;
  },100);
}

function setTextOfSubscription() {
  setTimeout(function(){
    if(document.querySelector('input[name="buyBundle"]:checked+label.label  .optionsPricesAndTexts')) {
      var first = document.querySelector('input[name="buyBundle"]:checked+label.label  .optionsPricesAndTexts .first');
      var second = document.querySelector('input[name="buyBundle"]:checked+label.label  .optionsPricesAndTexts .second');
      var third = document.querySelector('input[name="buyBundle"]:checked+label.label  .optionsPricesAndTexts .third');
      
      $('input[name="selectionSubscription12"]').prop('checked', false);
      // selectOption(2);
    }
  },100);
}

function selectOption(index) {
  setTimeout(function(){
    $('input[name="buyBundle"]:checked+label.label fieldset.sellingplans .abcWrap:nth-child('+index+') input').prop('checked', true);
  },100);
}

function activeIt() {
  setTimeout(function(){
  var ifchecked = document.querySelector('#toggleSubscription');
  if(!ifchecked)return;
  var classA;
  if(ifchecked.checked) {
  classA = 'active1';
  } else {
  classA = 'active2';
  }
  var lakshy = document.querySelector('div#chooseBetween2');
  if(lakshy) {
    lakshy.classList.remove('active1');lakshy.classList.remove('active2');
    lakshy.classList.add(classA);
    if(document.querySelector('div#chooseBetween2.active1')) {
    var selectorFound = document.querySelector('div#chooseBetween2.active1').querySelector('.flex.asasaasass.firstTab .justSwatchWrapper1 .fixDesignLabels:nth-child(2) label');
    if(selectorFound)selectorFound.click();
    } else if(document.querySelector('div#chooseBetween2.active2')){
    var selectorFound = document.querySelector('div#chooseBetween2.active2').querySelector('.flex.asasaasass.secondTab.justSwatchWrapper1 .fixDesignLabels:nth-child(2) label');
    if(selectorFound)selectorFound.click();
    }
  }
  // change text of button
  if(ifchecked.checked){
  //if(document.querySelector('.changeThisTextNow'))
  //document.querySelector('.changeThisTextNow').innerHTML = "ADD TO CART"
  }else{
  // if(document.querySelector('.changeThisTextNow'))
  // document.querySelector('.changeThisTextNow').innerHTML = "ADD TO CART"
  }
  },100);
}

setTextOfSubscription();
updatePricesPlzSubscription();

document.addEventListener("DOMContentLoaded", (event) => {
  var selectorFound = document.querySelector('div#chooseBetween2.active1').querySelector('.flex.asasaasass.firstTab .fixDesignLabels:nth-child(2) input');
  if(selectorFound)selectorFound.click();
});
 */





document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.totallNewStructure').forEach(section => {

    const sectionId = section.dataset.sectionId;
    const buyBtn = section.closest('.shopify-section')?.querySelector('.product_button_mh');
    const toggle = section.closest('.shopify-section')?.querySelector(`#toggleSubscription-${sectionId}`);

    /* ===============================
       UPDATE PRICES
    =============================== */
    function updatePrices() {

      const checked = section.querySelector(`input[name="buyBundle-${sectionId}"]:checked`);
      if (!checked) return;

      //const label = checked.nextElementSibling;
      const label = section.querySelector(`label[for="${checked.id}"]`);
      if (!label) return;

      const price = label.querySelector('.fullPrice')?.innerHTML;
      const quarter = label.querySelector('.quarterPrice')?.innerHTML;

      const fullTarget = section.closest('.shopify-section')?.querySelector('[data-element-type="pay-full-price"]');
      const quarterTarget = section.closest('.shopify-section')?.querySelector('[data-element-type="pay-part-price"]');

      if (fullTarget && price) fullTarget.innerHTML = price;
      if (quarterTarget && quarter) quarterTarget.innerHTML = quarter;

      const leftText = label.querySelector('.leftSideText')?.innerHTML;
      const rightText = label.querySelector('.rightSideText')?.innerHTML;

      const leftTarget = section.closest('.shopify-section')?.querySelector('.text_mh_left_p');
      const rightTarget = section.closest('.shopify-section')?.querySelector('.text_mh_right_p');

      if (leftTarget && leftText) leftTarget.innerHTML = leftText;
      if (rightTarget && rightText) rightTarget.innerHTML = rightText;
    }

    /* ===============================
       BUY BUNDLE
    =============================== */
    function buyBundle() {

      if (!buyBtn) return;

      buyBtn.classList.add('loading');

      const checked = section.querySelector(`input[name="buyBundle-${sectionId}"]:checked`);
      if (!checked) return;

      const submit = checked.closest('.pro_bd_mh')?.querySelector('product-form button[type="submit"]');

      if (submit) submit.click();

      setTimeout(() => {
        if (typeof shippingProtectionUpdate === "function") {
          shippingProtectionUpdate();
        }
        buyBtn.classList.remove('loading');
      }, 1500);
    }

    function selectMiddleOption() {

        let activeTab;

        if (section.classList.contains('active1')) {
          activeTab = section.querySelector('.firstTab');
        } else {
          activeTab = section.querySelector('.secondTab');
        }

        if (!activeTab) return;

        const radios = activeTab.querySelectorAll(`input[name="buyBundle-${sectionId}"]`);
        if (!radios.length) return;

        const middleIndex = Math.floor(radios.length / 2);
        const middleRadio = radios[middleIndex];

        if (middleRadio) {
          middleRadio.checked = true;
          middleRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }


    /* ===============================
       TOGGLE SUBSCRIPTION
    =============================== */
    function toggleSubscription() {

        if (!toggle) return;

        if (toggle.checked) {
          section.classList.add('active1');
          section.classList.remove('active2');
        } else {
          section.classList.add('active2');
          section.classList.remove('active1');
        }

        // Auto select middle option
        setTimeout(() => {
          selectMiddleOption();
        }, 50);
      }

    /* ===============================
       EVENTS
    =============================== */

    section.querySelectorAll(`input[name="buyBundle-${sectionId}"]`)
      .forEach(input => {
        input.addEventListener('change', updatePrices);
      });

    if (toggle) {
      toggle.addEventListener('change', toggleSubscription);
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', buyBundle);
    }

    // Initialize
   setTimeout(() => {
      if (toggle?.dataset.forceSubscriptionDefault === 'true') {
        toggle.checked = true;
      }
      updatePrices();
      toggleSubscription();
    }, 50);

  });

});



